import { CheckboxProps, IconButton, IconButtonProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import CheckIcon from '@mui/icons-material/Check'

export const KCheckIconButton = (
  props: IconButtonProps & Pick<CheckboxProps, 'checked'>,
) => {
  const theme = useTheme()
  const { checked, ...restProps } = props
  return (
    <IconButton
      {...restProps}
      sx={{
        width: 40,
        height: 40,
        border: checked ? 'none' : `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: checked ? theme.palette.primary.main : 'transparent',
        ':hover': {
          backgroundColor: checked
            ? theme.palette.primary[200]
            : theme.palette.grey[100],
        },
      }}
    >
      {checked && <CheckIcon sx={{ color: theme.palette.common.white }} />}
    </IconButton>
  )
}
